import { createValidation } from '../../../utils/validation';
export const createComplaintSourceValidation = (fields) => { const validation = createValidation(fields); return { schema: validation.schema, validateData: validation.validateData, validateComplaintSourceData: validation.validateData, validateField: validation.validateField }; };
export default createComplaintSourceValidation;

